import React from 'react';
import ReactDOM from 'react-dom/client';

import './styles/index.css';

import App from './App';
import {NavbarConsumer} from "./context/NavbarContext";
import {ReservationBookingProvider} from "./context/ReservationBookingContext";

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <>
        <React.StrictMode>
            <NavbarConsumer>
                <ReservationBookingProvider>
                    <App />
                </ReservationBookingProvider>
            </NavbarConsumer>
        </React.StrictMode>

    </>
);
